export const NAV_TESTID = {
    FAVORITE: "nav-favorite"
};

export const MOBILE_NAV_TESTID = {
    MOBILE_MENU: "nav-mobile-menu"
};
